var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#yuatecbswa)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "v70zwvrdob",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0V0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#v70zwvrdob)",
    stroke: "#fff",
    strokeWidth: 0.967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.707 10c0-5.361-4.346-9.707-9.707-9.707C4.639.293.293 4.639.293 10c0 5.36 4.346 9.707 9.707 9.707 5.361 0 9.707-4.346 9.707-9.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.566 8.747V7.495c0-.52.42-.94.939-.94h1.253c.173 0 .313-.14.313-.313V4.363a.313.313 0 0 0-.313-.313h-1.88a3.444 3.444 0 0 0-3.444 3.445V10H6.242a.313.313 0 0 0-.313.313v1.879c0 .173.14.313.313.313h2.192v5.636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.566 19.394v-6.89H13.2a.313.313 0 0 0 .304-.236l.47-1.88A.313.313 0 0 0 13.67 10h-2.104"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yuatecbswa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.7f0ef81252e90145f6dd63d229664eb6.svg";
export { ForwardRef as ReactComponent };